var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.posts),function(archive,index){return _c('li',{key:index},[_c('span',{staticClass:"cate"},[_vm._v(_vm._s(archive.publishedAt))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }